import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import useVenueAgeRestrictionOptions from '../../../shared/hooks/useVenueAgeRestrictionOptions';
import V3OfferSeatMapPicker from '../V3OfferSeatMapPicker';

// react-select carries its own (light) styling, so theme it off the simple
// page's tokens — these resolve to the original light values in light mode and
// to the dark palette under the dark page (O-3412).
const ageSelectStyles = {
  control: (base, state) => ({
    ...base,
    backgroundColor: 'var(--so-surface)',
    borderColor: state.isFocused ? 'var(--so-accent-border)' : 'var(--so-border)',
    boxShadow: 'none',
    ':hover': { borderColor: 'var(--so-border)' },
  }),
  singleValue: (base) => ({ ...base, color: 'var(--so-text)' }),
  input: (base) => ({ ...base, color: 'var(--so-text)' }),
  placeholder: (base) => ({ ...base, color: 'var(--so-muted)' }),
  menu: (base) => ({ ...base, backgroundColor: 'var(--so-surface)', border: '1px solid var(--so-border)' }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected ? 'var(--so-accent-subtle)' : (state.isFocused ? 'var(--so-surface-2)' : 'var(--so-surface)'),
    color: state.isSelected ? 'var(--so-accent)' : 'var(--so-text)',
  }),
  indicatorSeparator: (base) => ({ ...base, backgroundColor: 'var(--so-border)' }),
  dropdownIndicator: (base) => ({ ...base, color: 'var(--so-muted)' }),
  clearIndicator: (base) => ({ ...base, color: 'var(--so-muted)' }),
};

const SimpleEventDetailsCard = ({ ctrl }) => {
  const { options } = useVenueAgeRestrictionOptions(ctrl.team?.id, ctrl.offer?.venue_ownership_id);
  const [open, setOpen] = useState(true);

  const current = ctrl.offer?.age_restriction;

  return (
    <div className="simple-offer-card simple-event-details-card">
      <div className="simple-offer-card__header">
        <h3 className="simple-offer-card__title">Event Details</h3>
        <button
          type="button"
          className="simple-event-details-card__chevron"
          aria-label={open ? 'Collapse event details' : 'Expand event details'}
          onClick={() => setOpen((prev) => !prev)}
        >
          <i className={`fas fa-chevron-${open ? 'up' : 'down'}`} aria-hidden="true" />
        </button>
      </div>

      {open && (
        <div className="simple-event-details-card__body">
          <div className="simple-event-details-card__age-row">
            <label className="simple-event-details-card__toggle-label" htmlFor="simple-age-restriction">
              Age Limit
            </label>
            <div className="simple-event-details-card__age-select">
              <Select
                inputId="simple-age-restriction"
                classNamePrefix="simple-age-select"
                styles={ageSelectStyles}
                options={options}
                value={current ? { value: current, label: current } : null}
                placeholder="Select age restriction"
                isClearable
                onChange={(opt) => ctrl.updateOffer(ctrl.offer.id, { age_restriction: opt ? opt.value : null })}
              />
            </div>
          </div>
          <V3OfferSeatMapPicker />
        </div>
      )}
    </div>
  );
};

SimpleEventDetailsCard.propTypes = {
  ctrl: PropTypes.object.isRequired,
};

export default SimpleEventDetailsCard;
